import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import styles from './Contact.module.scss';
import { Input, Textarea, Button } from '@src/components/ui';
import { useBreakpoint } from '../../hooks/useBreakpoint';
import * as UserApi from "@src/api/UserApi";
const Contact = () => {
    const { isDesktop } = useBreakpoint();
    const width = isDesktop ? 335 : '100%';
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [isSubmittingForm, setIsSubmittingForm] = useState(false);
    const [isSuccessful, setIsSuccessful] = useState(false);
    const isFormValid = name.trim().length > 0 && email.trim().length > 0 && message.trim().length > 0;
    const handleSubmitForm = async () => {
        setIsSubmittingForm(true);
        try {
            const response = await UserApi.sendContactRequest(name, email, message);
            if (response.statusCode === 200) {
                setIsSuccessful(true);
            }
        }
        catch (e) {
            console.error(e);
        }
        finally {
            setIsSubmittingForm(false);
        }
    };
    return (_jsx("div", { className: styles.contact__wrapper, children: _jsx("div", { className: styles.contact__container, children: isSuccessful ? (_jsxs(_Fragment, { children: [_jsx("h2", { children: "Message Sent" }), _jsx("p", { children: "You will receive a response shortly." })] })) : (_jsxs(_Fragment, { children: [_jsx("h2", { children: "Contact Us" }), _jsx("p", { children: "Have a question or need assistance? We're here to help!" }), _jsxs("div", { className: styles.contact__inputs, children: [_jsx("div", { className: styles.contact__inputs__name, children: _jsx(Input, { label: "Name", width: width, onChange: setName, value: name }) }), _jsx("div", { className: styles.contact__inputs__email, children: _jsx(Input, { label: "Email", width: width, onChange: setEmail, value: email }) }), _jsx("div", { className: styles.contact__inputs__message, children: _jsx(Textarea, { label: "Your Message", width: width, height: 200, resizable: false, onChange: setMessage, value: message }) }), _jsx("div", { className: styles.contact__inputs__button, children: _jsx(Button, { onClick: handleSubmitForm, variant: "primaryV2", label: isSubmittingForm ? "Sending..." : "Send Message", size: 'large', disabled: isSubmittingForm || !isFormValid }) })] })] })) }) }));
};
export default Contact;
